module.exports = __webpack_public_path__ + "img/wind.3ce6c2cc.svg";